import React, { useMemo, useState } from "react";
import { useAllBranches } from "../../../../api/queries/organizationQueries";
import { toBranchTree } from "../../../../components/ui/BranchSelect";
import { branchChoices, movedBranches } from "./bioConfig";

const EMPTY = [];

/**
 * Branches that use a layout. A branch has one layout, so choosing one that
 * another layout holds moves it here: that is shown before saving.
 * companyId: the layout's company (its branches only); null = any company.
 */
const BranchMultiSelect = ({
  companyId,
  value,
  onChange,
  layouts = EMPTY,
  layoutId,
  disabled,
}) => {
  const query = useAllBranches();
  const [search, setSearch] = useState("");
  const all = Array.isArray(query.data) ? query.data : EMPTY;

  const tree = useMemo(
    () => toBranchTree(branchChoices(all, companyId, value)),
    [all, companyId, value],
  );
  const text = search.trim().toLowerCase();
  const shown = text
    ? tree.filter((b) => (b.branchName || "").toLowerCase().includes(text))
    : tree;
  const moves = movedBranches(value, layouts, layoutId, all);

  const toggle = (id) =>
    onChange(
      value.includes(id) ? value.filter((x) => x !== id) : [...value, id],
    );

  return (
    <>
      <label htmlFor="bl-branch-search" className="profile-label">
        Branches using this layout
      </label>
      {tree.length > 8 && (
        <input
          id="bl-branch-search"
          type="search"
          className="form-control form-control-sm mb-2"
          placeholder="Search branches"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      )}
      <div className="bio-branch-list" role="group" aria-label="Branches">
        {query.isLoading && (
          <div className="fs-080 text-slate-500">Loading branches…</div>
        )}
        {query.isError && (
          <div className="fs-080 text-danger">Could not load the branches.</div>
        )}
        {!query.isLoading && !query.isError && shown.length === 0 && (
          <div className="fs-080 text-slate-500">No branches found.</div>
        )}
        {shown.map((b) => (
          <label
            key={b.id}
            className="form-check fs-080"
            style={text ? undefined : { marginLeft: `${b.depth * 16}px` }}
          >
            <input
              type="checkbox"
              className="form-check-input"
              checked={value.includes(b.id)}
              onChange={() => toggle(b.id)}
              disabled={disabled}
            />
            <span className="form-check-label">{b.branchName}</span>
          </label>
        ))}
      </div>
      <div className="fs-070 text-slate-500 mt-1">
        Uploads for these branches use this layout. Sub-branches use it too,
        unless they have their own. A branch has one layout
        {companyId ? ", and only this company's branches are listed" : ""}.
      </div>
      {moves.length > 0 && (
        <div className="alert alert-warning fs-080 py-2 mt-2 mb-0" role="alert">
          Saving moves these branches to this layout:{" "}
          {moves.map((m) => `${m.branchName} (from ${m.from})`).join(", ")}.
        </div>
      )}
    </>
  );
};

export default BranchMultiSelect;
